import { AppStatic } from '../_helpers/app-static'

import { BaseClass } from './_base.model'

export class Service extends BaseClass {
  klass = 'Service'

  // obfuscated_id: string

  slug: string
  display: string
  price: number
  position: number

  get dollar_price(): string {
    // console.log('dollar-price', this)
    // let price = `$${this.price.toFixed(2)}`
    // console.log('dollar-price', price)
    return AppStatic.dollarValue(this.price) // `$${this.price.toFixed(2)}`
  }

  // isRole(role: string): boolean {
  //   // return true
  //   // const isRole = this.role == role
  //   let isRole: boolean
  //   this.role.split(',').map(str => {
  //     let trimmed = str.trim()
  //     if (role == trimmed) isRole = true
  //   })
  //   // console.log('isRole', isRole, this.role, role)
  //   return !!isRole
  // }

  // email_confirmed_at(): string {
  //   return 'TEST EMAIL CONFIRMED AT'
  // }

  // isSimilarTo(user: Order): boolean {
  //   if (!user) return false
  //   if (user && user['klass'] !== 'Order') return false
  //   return AppStatic.objectsAreSimilar(this, user)
  //   // return user.obfuscated_id === this.obfuscated_id
  // }
}
